module.exports = __webpack_public_path__ + "img/logo-small-beta.9715bb92.svg";